import React from 'react';
import { Link } from 'react-router-dom';

interface CardItemProps {
    campaign_requests_count?: number;
    campaigns_count?: number;
    name?: string;
}

const CardStaff: React.FC<CardItemProps> = ({
    campaign_requests_count,
    campaigns_count,
    name,
}) => {
    return (
        <div className='col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2'>
            <div className='flex h-full flex-col rounded-sm border border-stroke bg-white p-4 shadow-default dark:border-strokedark dark:bg-boxdark'>
                <div className='font-bold'>{name}</div>
                <div className='grid grid-cols-12 py-1'>
                    <div className='col-span-6'>
                        <Link to='/client-campaigns' className='text-primary'>
                            Campaigns
                        </Link>
                    </div>
                    <div className='col-span-6'>
                        <p className='text-right'>{campaigns_count}</p>
                    </div>
                </div>
                <div className='grid grid-cols-12 py-1'>
                    <div className='col-span-6'>
                        <Link to='/campaign-requests' className='text-primary'>
                            CRs
                        </Link>
                    </div>
                    <div className='col-span-6'>
                        <p className='text-right'>{campaign_requests_count}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardStaff;
